
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as come_45restituire_45Happy_45boxOGEUAVqTo7TgLuFQ9O4l2CtIcS5NcxCvHFsDK21_F_cMeta } from "/app/pages/come-restituire-Happy-box.vue?macro=true";
import { default as privacy_45policyzgG_S68_1GHrVnCshLKLsmg43yjC4fB7Q3UU1pkWXTMMeta } from "/app/pages/privacy-policy.vue?macro=true";
import { default as registration_45cardyVFn6GNHG2hrIcbTLQHMn9RFZpbTKILhOQFQVp7m_J0Meta } from "/app/pages/registration-card.vue?macro=true";
import { default as request_45partner_N_mFZCU24qcZe4kCEj2TXcE0adA_5wtCWpTtUPNUjwMeta } from "/app/pages/request-partner.vue?macro=true";
import { default as terms1wCL_jcKgXyjae_16VMbFrKHvZd0F4Waht3oN_MqrwYMeta } from "/app/pages/terms.vue?macro=true";
import { default as thank_45younfXQQV_m_nd4_hppzDzD5gaDFCMO3Gis_vsHgFrgkSEMeta } from "/app/pages/thank-you.vue?macro=true";
import { default as user_45verificationZfOTiSZ2v_JXZgmZNJErXuRqToMiwQuQpq29NJ9M8DUMeta } from "/app/pages/user-verification.vue?macro=true";
import { default as verify_45emailcrfHPrU4LwRvDPJwzEjjSYduPRZ3Xqz6TNa8vrqloPMMeta } from "/app/pages/verify-email.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_7f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
export default [
  {
    name: "come-restituire-Happy-box___pt",
    path: "/come-restituire-Happy-box",
    component: () => import("/app/pages/come-restituire-Happy-box.vue")
  },
  {
    name: "come-restituire-Happy-box___es",
    path: "/come-restituire-Happy-box",
    component: () => import("/app/pages/come-restituire-Happy-box.vue")
  },
  {
    name: "privacy-policy___pt",
    path: "/privacy-policy",
    component: () => import("/app/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___es",
    path: "/privacy-policy",
    component: () => import("/app/pages/privacy-policy.vue")
  },
  {
    name: "registration-card___pt",
    path: "/registration-card",
    meta: {"middleware":["email"]},
    component: () => import("/app/pages/registration-card.vue")
  },
  {
    name: "registration-card___es",
    path: "/registration-card",
    meta: {"middleware":["email"]},
    component: () => import("/app/pages/registration-card.vue")
  },
  {
    name: "request-partner___pt",
    path: "/request-partner",
    component: () => import("/app/pages/request-partner.vue")
  },
  {
    name: "request-partner___es",
    path: "/request-partner",
    component: () => import("/app/pages/request-partner.vue")
  },
  {
    name: "terms___pt",
    path: "/terms",
    component: () => import("/app/pages/terms.vue")
  },
  {
    name: "terms___es",
    path: "/terms",
    component: () => import("/app/pages/terms.vue")
  },
  {
    name: "thank-you___pt",
    path: "/thank-you",
    component: () => import("/app/pages/thank-you.vue")
  },
  {
    name: "thank-you___es",
    path: "/thank-you",
    component: () => import("/app/pages/thank-you.vue")
  },
  {
    name: "user-verification___pt",
    path: "/user-verification",
    component: () => import("/app/pages/user-verification.vue")
  },
  {
    name: "user-verification___es",
    path: "/user-verification",
    component: () => import("/app/pages/user-verification.vue")
  },
  {
    name: "verify-email___pt",
    path: "/verify-email",
    component: () => import("/app/pages/verify-email.vue")
  },
  {
    name: "verify-email___es",
    path: "/verify-email",
    component: () => import("/app/pages/verify-email.vue")
  },
  {
    name: "index___pt",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/",
    component: () => import("/app/pages/index.vue")
  }
]